import EDIconButton from '../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';

interface IProps {
  programLocationHeader: string;
  disabled?: boolean;
  routineKey: string | undefined;
  setDialogOpen: (open: boolean) => void;
}

/**
 * En knapp som öppnar upp en dialog som hänvisar till Aveny hjälp.
 */
const HelpButton: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <EDIconButton
      tooltip={!props.disabled ? 'Visa hjälp' : ''}
      onClick={() => {
        props.setDialogOpen(true);
      }}
      icon={<EDIcon iconType="help_filled" color="inherit" size="medium" />}
      color="inherit"
      margin="none"
      disabled={props.disabled}
    />
  );
};

export default HelpButton;
